import { Box, Stack } from '@mui/material';
import { WsColors, WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';

export type PageHeaderPropsType = {
  title: string;
};
const PageHeader = ({ title }: PageHeaderPropsType) => {
  return (
    <Box bgcolor={WsColors.TheBlues900} borderRadius={1.5} p={4}>
      <Stack direction={'row'} alignItems="center" spacing={2}>
        <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.TITLE}>
          {title}
        </WsTypography>
      </Stack>
    </Box>
  );
};
export default PageHeader;
